const upcomingSkillsOption = ({skills_upcoming, ordering, instrument}) => {

  if (!instrument || !skills_upcoming || !skills_upcoming.length > 0) return null;

  const first_skill = skills_upcoming[0] ? skills_upcoming[0] : '';
  const second_skill = skills_upcoming[1] ? skills_upcoming[1] : '';
  const third_skill = skills_upcoming[2] ? skills_upcoming[2] : '';

  const recentSkillData = {
    "order": ordering.skills_upcoming,
    "name": "skills_upcoming",
    "tracking": "skills_upcoming",
    "colorOption": 1,
    "dataPoints": {
      first_skill,
      second_skill,
      third_skill,
      instrument,
      title: 'upcoming'
    }
  };
  return recentSkillData;
}

export default upcomingSkillsOption;

